import { useIsStudioNewUi } from '@wix/package-picker-shared-studio';
import React from 'react';
import { PlansStepSkeleton } from '../../components/PageSkeleton';
import { StudioPackagePickerModule } from '../../modules/studio-package-picker.module';
import { SelectPlanPageSkeleton } from './SelectPlanPageSkeleton';

export const SelectPlanPageLoader = () => {
  const { ready } =
    StudioPackagePickerModule.internals.experiments.hooks.useExperiments();
  const isStudioNewUi = useIsStudioNewUi();

  if (!ready) {
    return null;
  }

  return isStudioNewUi ? <PlansStepSkeleton /> : <SelectPlanPageSkeleton />;
};
